// Port de app/(tabs)/menu.tsx.
import { Carregando } from "@/app/Carregando";
import { useIsFocused } from "@/navigation";
import { lazy } from "react";

const MeusDadosScreen = lazy(() => import("@/screens/MeusDados"));

export default function Menu() {
  const focused = useIsFocused();
  return focused ? (
    <Carregando>
      <MeusDadosScreen />
    </Carregando>
  ) : null;
}
